import { MaterialIcon } from 'mol-ui';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { minutesFormat } from 'shared/utils';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
    DataContainer,
    DataLine,
    NamesContainer,
    Text
} from './styled';
import React, { useState } from 'react';

const DoctorNames = ({
    callId,
    doctors: calls,
    pin,
    waitingRoom
}) => {

    const { t } = useTranslation();

    const [openNames, setOpenNames] = useState(false);
    
    const { doctor_last_name, doctor_name } = calls.length === 0 ? {} : calls[0];
    const hidePin = waitingRoom || isEmpty(pin) || calls.filter(({ status: { hidePin } }) => hidePin).length > 0;
    const openAvailable = calls.length > 1 || (!hidePin && !!pin);
    const { pin: pinText } = pin ?? {};

    return (
        <NamesContainer pointer={ openAvailable } onClick={ () => setOpenNames(openNames => openNames ? false : openAvailable) }>
            <Text fontSize="11px">
                { !isEmpty(pin) && !hidePin && `PIN: ${ pinText } - ` }
                { t('Profesional') }: { !hidePin ? t('No asignado') : `${ doctor_last_name }, ${ doctor_name }` }
            </Text>
            {
                openAvailable &&
                <>
                    <MaterialIcon display="inline-flex" icon={ !openNames ? 'arrow_drop_down' : 'arrow_drop_up' } size={ 14 } />
                    <DataContainer active={ openNames } items={ calls.length } onClick={ () => setOpenNames(false) }>
                        {
                            calls.map(({ call_duration, call_update, doctor_last_name, doctor_name, status: { color, icon, statusLabel } }, index) =>
                                <DataLine color={ color } key={ `${ callId }-${ index }` }>
                                    <MaterialIcon color={ color } icon={ icon } size={ 12 } />
                                    <span>{ moment(call_update).format('HH:mm') } -</span>
                                    <span>{ statusLabel } -</span>
                                    <span>{ doctor_last_name }, { doctor_name } </span>
                                    {
                                        call_duration > 0 && <span>- { minutesFormat(call_duration) }</span>
                                    }
                                </DataLine>
                            )
                        }
                    </DataContainer>
                </>
            }
        </NamesContainer>
    );
};

DoctorNames.propTypes = {
    callId: PropTypes.number,
    doctors: PropTypes.array,
    pin: PropTypes.object,
    waitingRoom: PropTypes.bool
};

export {
    DoctorNames
};
